import { Component } from '@angular/core';
import { Platform } from '@ionic/angular';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  constructor(
    private platform: Platform
  ) {
    this.initializeApp();
  }

  async initializeApp() {
    this.platform.ready().then(async () => {
      // Basic platform initialization only
      if (this.platform.is('capacitor')) {
        try {
          await StatusBar.hide();
        } catch (error) {
          console.error('[App] Error configuring status bar:', error);
        }
      }
      
      console.log('[App] Basic platform initialization complete');
      // Note: All application startup logic is now handled by the InitializationPage
    });
  }
}
